import { PURCHASE_STEP } from '~constants';
import { OrderItemType, Simulation } from '~types/appsync.types';
import { Participant } from '~types/participant';

interface ShouldShowNoOptionSelectedMessageParams {
  simulation?: Simulation;
  configurationStep: PURCHASE_STEP;
  participants: Participant[];
}

export const shouldShowNoOptionSelectedMessage = ({
  simulation,
  configurationStep,
  participants,
}: ShouldShowNoOptionSelectedMessageParams): boolean => {
  const hasBookingOptionWithoutTimeslot = participants.some((participant) =>
    participant.options.some((option) => option.isBooking && !option.timeslot),
  );

  const selectableOptions =
    simulation?.availableOptions?.filter(
      (option) => option.type !== OrderItemType.Support && !option.mandatory,
    ) ?? [];

  const hasSelectedOptions = participants.some((participant) => participant.options.length > 0);
  const shouldDisplayOptionsFlow = selectableOptions.length > 0;

  return (
    shouldDisplayOptionsFlow &&
    configurationStep === PURCHASE_STEP.OPTIONS &&
    !hasSelectedOptions &&
    !hasBookingOptionWithoutTimeslot
  );
};
